import React, {useState} from 'react';

const FilterTexts = ({filterTexts, setFilterTexts}) => {
    const [inputText, setInputText] = useState("");

    const handleInputOnchange = (e) => {
        setInputText(e.target.value);
    };

    const handleKeyPress = (e) => {
        if (e.key === "Enter") {
            const newFilterTag = inputText;

            setFilterTexts([newFilterTag, ...filterTexts]);
            setInputText("");
        }
    };

    const handleRemoveFilterTag = (newText) => {
        const restText = filterTexts.filter(filterTag => filterTag !== newText);
        setFilterTexts(restText);
    };

    return (
        <div className="container mx-auto flex flex-wrap">
            <input className="border mb-2 px-2"
                   type="text"
                   placeholder="enter a text"
                   value={inputText}
                   onChange={handleInputOnchange}
                   onKeyPress={handleKeyPress}/>

            <div className="m-1 px-2">User Input Filter Texts:</div>

            {filterTexts && filterTexts.map(tag =>
                <div key={tag}>
                    <div className="m-1 px-2 bg-gray-300 cursor-pointer flex">
                        <div className="mr-2">{tag}</div>
                        <button
                            onClick={() => {
                                handleRemoveFilterTag(tag);
                            }}
                        >x
                        </button>
                    </div>
                </div>,
            )}
        </div>
    );
};

export default FilterTexts;
